import React from 'react';
import { useLocation } from 'react-router-dom';
import { StorageLogout } from 'services/storage';

export default function ChangeEnvironment(props) {
    const location = useLocation();
    const [mensagem, setMensagem] = React.useState('... analisando');

    const setAmbiente = (value) => {
        StorageLogout();
        localStorage.clear();
        sessionStorage.setItem('@FPontos:ambiente', value);
    }

    React.useEffect(() => {
        if (location.pathname === '/prod') {
            setAmbiente('prod');
            setMensagem('redirecionando para ambiente de produção');
            setTimeout(() => {
            window.location = '/home'; 
            }, 2000);
            
        }
        else if (location.pathname === '/hml') {
            setAmbiente('hml');
            setMensagem('redirecionando para ambiente de homologacao');
            setTimeout(() => {
            window.location = '/home'; 
            }, 2000);
        }
        else {
            setMensagem('Ambiente não reconhecido, redirecionando para home');
            setTimeout(() => {
            window.location = '/home'; 
            }, 2000);
        }


    }, []);

    

    return (<div style={{marginTop: '100px'}}>{mensagem}</div>)
}